export default class CarManager {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el;
        this.data = parent.data;
        this.car = parent.car;
        this.pricing = parent.pricing;
        this.validator = parent.validator;
        this.resolver = parent.resolver;
        this.diff = parent.diff;
    }
   
    set(prop, id, dryRun) {
        const tempCar = this.car.clone();
        tempCar[prop] = id;
        return this.validateAndResolveConflicts(tempCar, prop, id, dryRun);
    }

    add(prop, id, dryRun) {
        const tempCar = this.car.clone();
        tempCar[prop].push(id);
        return this.validateAndResolveConflicts(tempCar, prop, id, dryRun);
    }

    replace(prop, id, replacement, dryRun) {
        const tempCar = this.car.clone();
        tempCar[prop] = tempCar[prop].filter((i) => i !== id);
        tempCar[prop].push(replacement);
        return this.validateAndResolveConflicts(tempCar, prop, replacement, dryRun);
    }

    remove(prop, id, dryRun) {
        const tempCar = this.car.clone();
        tempCar[prop] = tempCar[prop].filter((i) => i !== id);
        return this.validateAndResolveConflicts(tempCar, prop, id, dryRun);
    }

    validateAndResolveConflicts(tempCar, choiceType, choiceId, dryRun, silent) {
        let changes = 0;
        const conflictChain = [];

        let validate = this.validator.validate(tempCar);
        if (validate.valid) {
            if(dryRun) {
                return tempCar;
            } else {
                this.car.update(tempCar);
                return;
            }
        } else {
            conflictChain.push(validate);
        }
    
        while (!validate.valid) {
            this.resolver.resolve(tempCar, validate, choiceType, choiceId, dryRun);
            validate = this.validator.validate(tempCar);
            if(!validate.valid) {
                conflictChain.push(validate);
            }
            if (changes > 50) {
                console.error('Max changes reached, unable to resolve conflict', tempCar, validate);
                return;
            }
            changes++;
        }

        const diff = this.diff.check({ choiceType, choiceId, tempCar: tempCar, conflictChain });
    
        if(dryRun) {
            return tempCar;
        } else {
            const silentChain = conflictChain.reduce((res, c) => res && c.silent, true);
            if (diff.preventConflictModal || silent || silentChain ) {
                this.car.update(tempCar);
            } else {
                this.parent.conflictModal.onConfirm = () => this.car.update(tempCar);
                this.parent.conflictModal.show(diff, tempCar);
            }
        }
    }  
}
